
import { ref, reactive, ComponentOptions } from 'vue';
import useCompanyStore from "../stores/company.store";
import { IPlan } from './plan.interface';
import { PlanService } from './plan.service';
import { CompanyInfoEnum } from '../stores/company.enum';
// export default
class PlanComponent implements ComponentOptions {
  public fields = reactive({ plan: '' });
  public plans = ref<IPlan[]>([]);
  public planCategory: string = '';

  constructor() {
    this.init();
  }

  async init() {
    this.plans.value = await (new PlanService()).getPlans();
    this.planCategory = this.plans.value[0].category;
  }

  save(plan: IPlan) {
    const companyStore = useCompanyStore();
    console.log(plan);
    companyStore.store(CompanyInfoEnum.PlanName, plan['name']);
    companyStore.store(CompanyInfoEnum.PlanType, plan['category']);
  }
}
export default new PlanComponent();